import React from "react";
import { AuthProvider } from "./AuthContext";
import { ProfileProvider } from "./ProfileContext";
import { ChatProvider } from "./ChatContext";

export const AppContextProvider = ({ children }) => {
    return (
        <AuthProvider>
            <ProfileProvider>
                <ChatProvider>{children}</ChatProvider>
            </ProfileProvider>
        </AuthProvider>
    );
};
